import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import type { ITooltipProps } from "@similarweb/ui-components";
import { Text, type TextProps } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { INLINE_LINE_HEIGHT, StyledAgentCaption } from "./styles";
import { TooltipContent } from "./TooltipContent";

const TOOLTIP_DELAY: ITooltipProps["delay"] = {
    open: 100,
    close: 100,
};

type Props = {
    className?: string;
    isInline?: boolean;
    textId?: string;
    shouldWrap?: boolean;
} & Partial<Pick<TextProps, "fontVariant">>;

const AIAgentCaption = ({
    className,
    fontVariant = "caption",
    isInline = false,
    textId = "si.pages.ai_agent.caption",
    shouldWrap = false,
}: Props) => {
    return (
        <StyledAgentCaption
            className={className}
            data-automation="ai-agent-caption"
            isInline={isInline}
        >
            <Text
                fontVariant={fontVariant}
                color={colorsPalettes.carbon[300]}
                whiteSpace={shouldWrap ? "normal" : "nowrap"}
            >
                {translate(textId)}
            </Text>

            <Tooltip
                content={<TooltipContent />}
                delay={TOOLTIP_DELAY}
            >
                <SWReactIcons
                    iconName="info"
                    size={isInline ? INLINE_LINE_HEIGHT : "xs"}
                />
            </Tooltip>
        </StyledAgentCaption>
    );
};

export default AIAgentCaption;
